
import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";

function NcReportModal_3({ show, handleClose,onNcReport }) {
  const [listLoading, setListLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    selectedProduct: null,
    selectedType: null,
    ncQuantity: "",
    unit: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  // Fetch product list
  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductList(res.data.products || []);
    } catch (err) {
      console.error("Error fetching product list:", err);
      toast.error("Failed to load product list");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchProductList();
  }, []);

  const productOptions = productList.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  const typeOptions = [
    { value: "material", label: "Material" },
    { value: "product", label: "Product" },
  ];

  // Unified handler for all fields
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: null,
    }));
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("No authentication token found");
      return;
    }

    try {
      const payload = {
        product_name: formData.selectedProduct ? formData.selectedProduct.value : null,
        product_type: formData.selectedType ? formData.selectedType.value : null,
        nc_quantity: Number(formData.ncQuantity),
        unit: formData.unit,
        description: formData.description,
      };

      console.log("Submitting payload:", payload);

      const res = await axios.post(
        `${config.API}/supervisor/ncreportslog`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", res.data);
      toast.success(res.data.message || "NC Report submitted successfully");
      
      // Reset form
      setFormData({
        selectedProduct: null,
        selectedType: null,
        ncQuantity: "",
        unit: "",
        description: "",
      });
      setErrors({});
      onNcReport()
      handleClose();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error(err.response?.data?.message || "Something went wrong");
      }
      console.error("Error submitting NC report:", err.response?.data || err.message);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="font_family">
      <Modal.Header closeButton>
           <strong className="fs-3">NC Report</strong>
      </Modal.Header>
      <Modal.Body className="">
        {/* Product Type */}
        <Row className="mb-3 align-items-center mt-4">
          <Col md={2}>
            <Form.Label><strong>Product Type</strong></Form.Label>
          </Col>
          <Col md={10}>
            <Select
              options={typeOptions}
              value={formData.selectedType}
              onChange={(option) => handleChange("selectedType", option)}
              placeholder="Select Product Type"
            />
            {errors.selectedType && (
              <div className="text-danger">{errors.selectedType}</div>
            )}
          </Col>
        </Row>

        {/* Product Name */}
        <Row className="mb-3 align-items-center">
          <Col md={2}>
            <Form.Label><strong>Product Name</strong></Form.Label>
          </Col>
          <Col md={10}>
            <Select
              options={productOptions}
              value={formData.selectedProduct}
              onChange={(option) => handleChange("selectedProduct", option)}
              isLoading={listLoading}
              placeholder="Select Product"
            />
            {errors.product_name && (
              <div className="text-danger">{errors.product_name}</div>
            )}
          </Col>
        </Row>

        {/* NC Quantity and Unit */}
        <Row className="mb-4 align-items-center">
          <Col md={3}>
            <Form.Label><strong>NC Quantity</strong></Form.Label>
          </Col>
          <Col md={3}>
            <Form.Control
              type="number"
              value={formData.ncQuantity}
              onChange={(e) => handleChange("ncQuantity", e.target.value)}
            />
            {errors.nc_quantity && (
              <div className="text-danger">{errors.nc_quantity}</div>
            )}
          </Col>
          <Col md={2}>
            <Form.Label><strong>Unit</strong></Form.Label>
          </Col>
          <Col md={3}>
            <Form.Control
              type="text"
              value={formData.unit}
              onChange={(e) => handleChange("unit", e.target.value)}
            />
            {errors.unit && (
              <div className="text-danger">{errors.unit}</div>
            )}
          </Col>
        </Row>

        {/* Description */}
        <div className="border rounded p-3 mb-3 mt-4">
          <div className="bg-secondary-subtle text-muted p-3 rounded mb-3 w-75">
            Please describe the reason for NC report. You can provide details about what you're seeing, upload an image, or use voice input.
          </div>
          <div className="border rounded p-2">
            <div className="d-flex align-items-center">
              <div className="d-flex gap-2">
                <Button variant="light" className="border"><FaUpload /></Button>
                <Button variant="light" className="border"><FaMicrophone /></Button>
              </div>

              <div className="flex-grow-1 mx-2">
                <textarea
                  className="form-control border-0 shadow-none"
                  rows="1"
                  placeholder="Type here..."
                  style={{ resize: "none" }}
                  value={formData.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>

              <div>
                <Button variant="primary" onClick={handleSubmit}>
                  <FaPaperPlane />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default NcReportModal_3;


